"use client";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl, localUrl } from "../../config/baseUrl";
import empty from "../../assets/images/empty-box.png";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faCheck,
  faTimes,
  faSearch,
  faBox,
  faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

export default function BusinessList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        // `${localUrl}/admin/business/list?page=1`, {
        `${baseUrl}/admin/business/list?page=1`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res?.data.status) {
        setData(res.data.data || res.data || []);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (Id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    try {
      const response = await axios.put(
        // `http://localhost:3000/admin/product/status/${Id}`,
        `${baseUrl}/admin/product/status/${Id}`,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status) {
        fetchData();
        toast.success("Notification status changed!");
      } else {
        throw new Error(
          response.message || "Failed to update notification status"
        );
      }
    } catch (error) {
      console.error("Error updating notification status:", error);
      toast.error("Failed to update notification status. Please try again.");
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
          // `http://localhost:3000/admin/product/delete/${id}`, {
          `${baseUrl}/admin/product/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        fetchData();
        Swal.fire("Deleted!", "Notification has been deleted.", "success");
      } catch (error) {
        Swal.fire("Error!", "Failed to delete notification.", "error");
      }
    }
  };

  // Filter notifications based on search term
  // const filteredProducts = products.filter((product) =>
  //   product.productName.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const truncateText = (text, maxLength = 100) => {
    return text?.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  return (
    <>
      <section className="main-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6">
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <FontAwesomeIcon icon={faBuilding} className="me-2" />
                  Business & Places
                </h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Business
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            {/* <div className="col-lg-6 d-flex justify-content-end align-items-start">
              <Link to="create" className="btn btn-for-add text-white">
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Add Products
              </Link>
            </div> */}
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="cards">
                <div className="bus-filter">
                  <div className="row align-items-center">
                    <div className="col-lg-6">
                      <h5 className="card-title">
                        Business List ({data.length})
                      </h5>
                    </div>
                  </div>
                </div>

                <div className="table-responsive custom-table">
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>Image</th>
                        <th>Title</th>
                        <th>Phone</th>
                        <th>Description</th>
                        <th>Type</th>
                        <th>Status</th>
                        {/* <th>Actions</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="loading-spinner">
                            <div className="spinner"></div>
                          </td>
                        </tr>
                      ) : data.length === 0 ? (
                        <tr>
                          <td colSpan="5" className="empty-state">
                            <img
                              src={empty || "/placeholder.svg"}
                              alt="No product"
                              width="200px"
                            />
                            <h4>No data found!</h4>
                            <p className="text-muted">
                              {searchTerm
                                ? "Try adjusting your search criteria"
                                : "Start by adding your first notification"}
                            </p>
                          </td>
                        </tr>
                      ) : (
                        data.map((item, i) => (
                          <tr key={item?.id}>
                            <td>{i + 1}</td>
                            <td>
                              <img
                                //   src={`${localUrl}/${item?.first_image}`}
                                src={`${baseUrl}/${item?.first_image}`}
                                alt="profile"
                                style={{ width: "60px" }}
                              />
                            </td>
                            <td>
                              <div className="notification-details">
                                <h6>{truncateText(item?.title, 30)}</h6>
                              </div>
                            </td>
                            <td>{item?.phone || "N/A"}</td>

                            <td>{truncateText(item?.description, 30)}</td>

                            <td>{item?.type || "N/A"}</td>
                            <td>
                              <select
                                className="form-select"
                                value={item?.status || "Pending"}
                                // onChange={(e) =>
                                //   handleStatus(user?.id, e.target.value)
                                // }
                                style={{
                                  minWidth: "120px",
                                  textTransform: "capitalize",
                                }}
                              >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                            </td>
                            {/* <td>
                              <div className="action-buttons">
                                <Link
                                  to={`/products/edit/${item?.id}`}
                                  className="action-btn edit-btn"
                                >
                                  <FontAwesomeIcon icon={faEdit} />
                                  <span className="tooltip-text">Edit</span>
                                </Link>
                                <button
                                  className="action-btn delete-btn"
                                  onClick={() => handleDelete(item?.id)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                  <span className="tooltip-text">Delete</span>
                                </button>
                              </div>
                            </td> */}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
